import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { AppConstantsService } from '../services/app-constants.service';
import { ConfigManagerProperties } from '../enums/config-manager-properties.enum';
import { map } from 'rxjs/operators';
import { RouterUriComponents } from '../enums/router-uri-components.enum';
import { User } from '@xpo-ltl/sdk-common';
import { LoginService } from 'app/login/services/login.service';

@Injectable({
  providedIn: 'root',
})
export class NotAuthorizedRedirectGuard implements CanActivate {
  constructor(private loginService: LoginService, private config: ConfigManagerService, private router: Router, private appConstantsService: AppConstantsService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const results: Subject<boolean> = new Subject<boolean>();

    return this.loginService.getLoggedInUser(this.config.getSetting(ConfigManagerProperties.loggedInUserRoot)).pipe(
      map((user: User) => {
        if (this.appConstantsService.isAthorizedUser(user)) {
          this.appConstantsService.user = user;
          this.router.navigate([RouterUriComponents.LIST_PAYFORMS]);
          return true;
        }
        this.appConstantsService.user = undefined;
        return false;
      })
    );
  }
}
